import React, { useState, useEffect } from "react";
import { Box, Button, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { DummyExamHeader } from "./DummyExamHeader";
import { DummyQuestionTabs } from "./DummyQuestionTabs";
import { DummyQuestionPopup } from "./DummyQuestionPopUp";
import { DummySubmitSuccessPopup } from "./DummySubmitSuccessPopup";
import DummySubmitVivaDialog from "./DummySubmitVivaDialog";
import { DummyExamName } from "./DummyExamName";
import "../VivaExam/VivaExam.css";

import { DummyuseRecording } from "./DummyuseRecording";

const dummyQuestions = [
  { Id: "q1", QuestionDescription: "Please introduce yourself and tell us about your background.", IsMandatory: 1 },
  // Add more questions if needed
];

export const DummyRightCard = ({
  currentQuestion,
  setCurrentQuestion,
  questionStatus,
  setQuestionStatus,
  isRecording,
  setIsRecording,
  stream,
  setStream,
  audioStream,
  setAudioStream,
  showPopup,
  setShowPopup,
}) => {
  const navigate = useNavigate();

  const [questions] = useState(dummyQuestions);
  const [showSuccess, setShowSuccess] = useState(false);
  const [timeLeft, setTimeLeft] = useState(25 * 60);
  const [showSubmitDialog, setShowSubmitDialog] = useState(false);
  const [forceSubmit, setForceSubmit] = useState(false);
  const [isSubmitting] = useState(false);

  const { startRecording, stopRecording } = DummyuseRecording({
    setAudioStream,
    setStream,
    setIsRecording,
    currentQuestion,
    setQuestionStatus,
    currentVivaQuestionId: questions[currentQuestion]?.Id,
  });

  useEffect(() => {
    if (timeLeft <= 0) return;
    const interval = setInterval(() => {
      setTimeLeft((prev) => Math.max(0, prev - 1));
    }, 1000);
    return () => clearInterval(interval);
  }, [timeLeft]);

  const qId = questions[currentQuestion]?.Id;

  const handleAnswerClick = () => {
    if (questionStatus[qId] === "answered") {
      alert("You have already answered this question.");
      return;
    }
    setShowPopup(true);
  };

  const handleSave = async () => {
  try {
    const { audioBlob } = await stopRecording();
    console.log("[Save] Audio saved:", audioBlob?.size || 0);
  } catch (err) {
    console.error("[Save] Error:", err);
  }

  // Emergency final cleanup – in case anything survived
  if (stream) {
    console.log("[Save] Emergency track stop");
    stream.getTracks().forEach(t => {
      t.stop();
      t.enabled = false;
    });
  }

  setStream(null);
  setAudioStream(null);
  setIsRecording(false);
  setShowPopup(false);

  setTimeout(() => {
    const qId = questions[currentQuestion]?.Id;
    console.log("[Save] Status after delay:", questionStatus[qId]);
    if (currentQuestion < questions.length - 1) {
      setCurrentQuestion(currentQuestion + 1);
    }
  }, 400);
};

  const handleFinalSubmit = () => {
    setShowSubmitDialog(false);
    setShowSuccess(true);
  };

  const handleTimeUp = () => {
    setShowSubmitDialog(true);
    setForceSubmit(true);
  };

  // const handlePopupClose = () => {
  //   setShowSuccess(false);
  //   navigate("/users/dashboard", { state: { message: "Exam completed (dummy)" } });
  // };

  const handlePopupClose = async () => {
  await exitFullscreen();

  setShowSuccess(false);

  navigate("/users/dashboard", {
    state: { message: "Exam completed (dummy)" }
  });
};


  const exitFullscreen = async () => {
  try {
    if (document.fullscreenElement) {
      await document.exitFullscreen();
    } else if (document.webkitFullscreenElement) {
      await document.webkitExitFullscreen();
    } else if (document.msFullscreenElement) {
      await document.msExitFullscreen();
    }
  } catch (err) {
    console.warn("Error while exiting fullscreen:", err);
  }
};


  return (
    <Box className="exam-card" sx={{ width: "100%", minHeight: "100%", p: 2 }}>
      <DummyExamName />

      <DummyExamHeader
        currentQuestion={currentQuestion}
        totalQuestions={questions.length}
        isRecording={isRecording}
        questionStatus={questionStatus}
        timeLeft={timeLeft}
        onTimeUp={handleTimeUp}
      />

      <DummyQuestionTabs
        currentQuestion={currentQuestion}
        setCurrentQuestion={setCurrentQuestion}
        questionStatus={questionStatus}
        questions={questions}
      />

      { !showSuccess && (
        <Box
          sx={{
            border: "1px solid #ccc",
            textAlign: "center",
            mt: 2,
            flexGrow: 1,
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            pt: 4,
            pb: 6,
          }}
        >
          {questionStatus[qId] === "answered" ? (
            <Box>
              <Typography variant="h6" gutterBottom>
                <p>✅ Answer Saved</p>
                <p>You can continue to the next question or submit.</p>
              </Typography>
            </Box>
          ) : (
            <>
              <Box className="question-text" sx={{ fontSize: 20, fontWeight: 600, mb: 4 }}>
                {questionStatus[qId] === "not-started" && (
                  <>
                    <Box sx={{ pt: 5 }}>Are you ready to answer this question?</Box>
                    <Box sx={{ fontSize: 40, mb: 2, color: "var(--brand)" }}>
                      <i className="fa fa-question-circle"></i>
                    </Box>
                  </>
                )}
                {questionStatus[qId] === "recording" && questions[currentQuestion]?.QuestionDescription}
              </Box>

              {questionStatus[qId] !== "answered" && (
                <Button className="answer-button" onClick={handleAnswerClick}>
                  Answer
                </Button>
              )}
            </>
          )}
        </Box>
      )}

      {showPopup && (
        <div className="modal-overlay">
          <DummyQuestionPopup
            question={questions[currentQuestion]}
            currentQuestion={currentQuestion}
            isRecording={isRecording}
            stream={stream}
            audioStream={audioStream}
            startRecording={startRecording}
            handleSave={handleSave}
            onClose={() => {
              setShowPopup(false);
              setStream(null);
              setAudioStream(null);
              setIsRecording(false);
            }}
          />
        </div>
      )}

      <DummySubmitVivaDialog
        open={showSubmitDialog}
        onClose={() => setShowSubmitDialog(false)}
        forceSubmit={forceSubmit}
        isSubmitting={isSubmitting}
        onConfirm={handleFinalSubmit}
        questions={questions}
        questionStatus={questionStatus}
      />

      {showSuccess && (
        <div className="modal-overlay">
          <DummySubmitSuccessPopup onClose={handlePopupClose} autoClose={handlePopupClose} />
        </div>
      )}

      {!showSuccess && (
        <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2, gap: 2 }}>
          <Button
            className="btn vivasubmit-btn"
            color="error"
            size="large"
            onClick={() => {
              setForceSubmit(false);
              setShowSubmitDialog(true);
            }}
          >
            Submit
          </Button>
        </Box>
      )}
    </Box>
  );
};